module.exports = __webpack_public_path__ + "img/yearbook.01d7a98b.jpg";